import 'core-js/features/object/values';
import 'core-js/features/object/entries';

declare global {
  interface Window {
    IntersectionObserver: typeof IntersectionObserver;
  }
}

export const loadPolyfills = async () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    // @ts-ignore
    await import('intersection-observer');
  }
};
